import { Sparkles } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[#0B1530] py-14 md:py-16 pb-32 md:pb-32" data-testid="footer">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <div className="flex items-center gap-2 mb-8">
        <span className="w-8 h-8 rounded-xl bg-gradient-to-br from-blue-600 to-cyan-500 flex items-center justify-center">
          <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
        </span>
        <span className="font-heading font-extrabold text-lg tracking-tight text-white">
          Hotaro<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">Digital</span>
        </span>
      </div>

      <div className="space-y-4 text-xs leading-relaxed text-slate-400 max-w-4xl">
        <p className="font-bold text-slate-300 uppercase tracking-wider">Disclaimer</p>
        <p>Produk yang ditawarkan adalah layanan penyediaan akses/paket keanggotaan sesuai deskripsi yang berlaku saat pembelian.</p>
        <p>
          Kami bukan afiliasi, partner resmi, maupun perwakilan dari Google LLC, OpenAI, ataupun Anthropic. Seluruh merek dagang, logo,
          dan nama produk merupakan milik masing-masing pemiliknya dan digunakan hanya sebagai referensi untuk menjelaskan kompatibilitas
          atau layanan yang ditawarkan.
        </p>
        <p>Harga, fitur, dan ketersediaan layanan dapat berubah mengikuti kebijakan penyedia layanan terkait.</p>
        <p>
          Dengan melakukan pembelian, pelanggan dianggap telah membaca dan menyetujui syarat layanan, kebijakan pengiriman, serta
          ketentuan garansi yang berlaku.
        </p>
        <p>
          Landing page dan materi promosi dibuat untuk tujuan informasi dan pemasaran yang sah serta tidak dimaksudkan untuk menyesatkan
          atau mengklaim hubungan resmi dengan pemilik merek.
        </p>
      </div>

      <div className="mt-10 pt-6 border-t border-white/10 text-xs text-slate-500">
        © {new Date().getFullYear()} HotaroDigital. Seluruh hak cipta dilindungi.
      </div>
    </div>
  </footer>
);
